(function () {
  function formatCartCount(count) {
    const safeCount = Math.max(0, parseInt(count, 10) || 0);
    if (safeCount === 0) return '';
    return safeCount < 100 ? String(safeCount) : '99+';
  }

  function setHeaderCartCount(count) {
    const display = formatCartCount(count);

    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = display;
    });

    document.querySelectorAll('.header-cart-link .header-cart-icon').forEach((icon) => {
      const link = icon.closest('.header-cart-link');
      if (!link) return;

      const label =
        display === ''
          ? 'Cart'
          : `Cart, ${Math.max(0, parseInt(count, 10) || 0)} item${count === 1 ? '' : 's'}`;
      link.setAttribute('aria-label', label);
    });
  }

  function fetchCartCount() {
    const cartUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js';
    return fetch(cartUrl)
      .then((response) => response.json())
      .then((cart) => cart.item_count)
      .catch(() => null);
  }

  function resolveCartCount(cartData) {
    if (cartData && typeof cartData.item_count === 'number') {
      return Promise.resolve(cartData.item_count);
    }
    return fetchCartCount();
  }

  function handleCartUpdate(event) {
    resolveCartCount(event.cartData).then((count) => {
      if (count != null) setHeaderCartCount(count);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  });
})();
